import { Apollo, gql } from 'apollo-angular';
import { Seq } from 'immutable';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import {
  MedicalFacilityViewModel_GetMedicalFacilityContactIds,
  MedicalFacilityViewModel_GetMedicalFacilityContactIdsVariables,
} from 'src/app/shared/graphql/graphql-request-types';
import { ViewModelService } from 'src/app/shared/view-model.service';
import { selectMedicalFacilityContactEntitiesByMedicalFacilityId } from 'src/store/generated/medical-facility-contact-record.generated';
import {
  MedicalFacilityProps,
  MedicalFacilityViewModelBase,
} from 'src/store/generated/medical-facility-record.generated';
import { LocationViewModel } from './location-view-model';
import { MedicalFacilityContactViewModel } from './medical-facility-contact-view-model';

export class MedicalFacilityViewModel extends MedicalFacilityViewModelBase {
  public contacts$: Observable<Seq.Indexed<MedicalFacilityContactViewModel>>;
  constructor(
    props: MedicalFacilityProps,
    public readonly location: LocationViewModel | undefined,
    model: ViewModelService,
  ) {
    super(props);
    this.contacts$ = model.medicalFacilityContacts
      .getMany({
        cacheSelector: selectMedicalFacilityContactEntitiesByMedicalFacilityId(this.id),
        getIdsFallback: getMedicalFacilityContactIds(this.id, model.apollo),
      })
      .pipe(map((contacts) => contacts.map((c) => new MedicalFacilityContactViewModel(c, this))));
  }
}

function getMedicalFacilityContactIds(facilityId: string, apollo: Apollo): Observable<string[]> {
  return apollo
    .query<
      MedicalFacilityViewModel_GetMedicalFacilityContactIds,
      MedicalFacilityViewModel_GetMedicalFacilityContactIdsVariables
    >({
      query: gql`
        query MedicalFacilityViewModel_GetMedicalFacilityContactIds($facilityId: ID!) {
          medicalFacilities {
            byId(id: $facilityId) {
              contacts {
                id
              }
            }
          }
        }
      `,
      variables: {
        facilityId,
      },
    })
    .pipe(
      filter((r) => r == null || !r.loading),
      map((r) => {
        const facility = r.data.medicalFacilities.byId;
        if (facility != null) {
          return facility.contacts.map((c) => c.id);
        }
        return [];
      }),
    );
}
